




































  import {Component, Prop, Mixins} from 'vue-property-decorator'
  import TravelTag from '@/components/travel/TravelTag.vue'
  import {resolveTravelImageMixin} from '@/mixins/resolveImageMixin'
  import {ITravel} from '@/entities'
import { isEqual } from 'lodash'
import { ITravelAdditions } from '@/entities/travel/additions/travelAdditions'
import i18n from '@/i18n'

  @Component({
    components: {
      TravelTag
    }
  })
  export default class TravelLayoutCard extends Mixins(resolveTravelImageMixin) {

    @Prop() readonly data!: ITravel
    get travel(): ITravel | null | undefined {
      return this.data;
    }

    get price(): string {
      return this.$storage.getters.getPriceLabel(this.data.price);
    }

    private cacheTravel(): void {
      this.$storage.actions.setTravel(this.data);
    }

    get travelDate(): string {
      let res = '';
      let currentGroupTravelAdditions!: ITravelAdditions;

      if (this.travel?.travel_additions) {
        currentGroupTravelAdditions = this.travel.travel_additions;
      }

      return `${this.handleDate(currentGroupTravelAdditions.date_from as string, false)}-${this.handleDate(currentGroupTravelAdditions.date_to as string, true)}`;
    }

    handleDate(currentDate: string, disableYear: boolean): string {
      const startDate = new Date(currentDate);
      const date = ('0' + startDate.getDate()).slice(-2);
      const month = ('0' + (startDate.getMonth() + 1)).slice(-2);
      const year = disableYear ? `.${startDate.getFullYear().toString().slice(-2)}` : '';

      return `${date}.${month}${year}`;
    }

  }
